
export class Emplado {
    id: number;
    idEmisor: string;
    nombres: string;
    cedula: string;
    telefono: string;
    estado: string;
    }
    